var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7679 3.5C13.5377 2.16667 15.4623 2.16667 16.2321 3.5L24.8923 18.5C25.6621 19.8333 24.6999 21.5 23.1603 21.5H5.83975C4.30015 21.5 3.3379 19.8333 4.1077 18.5L12.7679 3.5Z",
    fill: "#FC1414"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.844 14.906L13.592 8.2H15.174L14.908 14.906H13.844ZM14.39 18.084C14.1287 18.084 13.9093 17.9953 13.732 17.818C13.5547 17.6407 13.466 17.4307 13.466 17.188C13.466 16.9267 13.5547 16.712 13.732 16.544C13.9093 16.376 14.1287 16.292 14.39 16.292C14.6513 16.292 14.866 16.376 15.034 16.544C15.202 16.712 15.286 16.9267 15.286 17.188C15.286 17.4307 15.202 17.6407 15.034 17.818C14.866 17.9953 14.6513 18.084 14.39 18.084Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertTriangle);
export default __webpack_public_path__ + "static/media/alert-triangle.563300a69a70ac9ead9ff343a4148744.svg";
export { ForwardRef as ReactComponent };